// RxJS
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPatientHeightsInStore,
  selectPatientHeightsPageLoading,
  selectPatientHeightsShowInitWaitingMessage,
} from '../_selectors/patient-height.selectors';

export class PatientHeightsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPatientHeightsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPatientHeightsShowInitWaitingMessage));

    this.store
      .pipe(select(selectPatientHeightsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
